// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__KbgH6","content":"Modal_content__arPAQ","button":"Modal_button__RGc7V"};